import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { BlockingLoaderDialogComponent } from './blocking-loader-dialog.component';
import { BlockingLoaderService } from './blocking-loader.service';


@NgModule({
    imports: [
        CommonModule,
        MatProgressSpinnerModule,
    ],
    declarations: [
        BlockingLoaderDialogComponent,
    ],
    exports: [
        BlockingLoaderDialogComponent,
    ],
})
export class BlockingLoaderModule {

    static forRoot(): ModuleWithProviders<BlockingLoaderModule> {
        return {
            ngModule: BlockingLoaderModule,
            providers: [
                BlockingLoaderService,
            ],
        };
    }

}

